import { render, staticRenderFns } from "./index.vue?vue&type=template&id=1aaf0798&"
import script from "./index.vue?vue&type=script&setup=true&lang=ts&"
export * from "./index.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1aaf0798')) {
      api.createRecord('1aaf0798', component.options)
    } else {
      api.reload('1aaf0798', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=1aaf0798&", function () {
      api.rerender('1aaf0798', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/info/legal-case/index.vue"
export default component.exports